import(/* webpackMode: "eager", webpackExports: ["MyAchievements"] */ "/vercel/path0/components/pages/achiments.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Contact"] */ "/vercel/path0/components/pages/contact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/vercel/path0/components/pages/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Projects"] */ "/vercel/path0/components/pages/projects.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Skills"] */ "/vercel/path0/components/pages/skills.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Stats"] */ "/vercel/path0/components/pages/stats.tsx");
